import { render, staticRenderFns } from "./PlotlyChart.vue?vue&type=template&id=7f8ff588&scoped=true"
import script from "./PlotlyChart.vue?vue&type=script&lang=js"
export * from "./PlotlyChart.vue?vue&type=script&lang=js"
import style0 from "./PlotlyChart.vue?vue&type=style&index=0&id=7f8ff588&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f8ff588",
  null
  
)

export default component.exports